// ============================================================================
// VERSIÓN DE LA APLICACIÓN — SemVer (MAJOR.MINOR.PATCH)
//
// Subir el número aquí cada vez que se haga un release:
//   - PATCH (1.5.0 -> 1.5.1): corrección de bug o ajuste menor sin nueva feature
//   - MINOR (1.5.0 -> 1.6.0): nueva funcionalidad visible al usuario
//   - MAJOR (1.x   -> 2.0.0): cambio grande, rediseño o ruptura importante
//
// Además, agregar la entrada correspondiente en frontend/src/pages/Bitacora.jsx
// con el campo `version` que coincida con este número.
// ============================================================================

export const APP_VERSION = '1.33.1';

// Fecha del último release (opcional, para mostrarla en algún lado)
export const APP_VERSION_DATE = '2026-08-09';
